<tt-page *ngIf="!!categoryData">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="selectionCriterias"></ng-container>
        </tt-card>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="categorydataselect_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 p-5">
                        <ng-container *ngTemplateOutlet="selectionCriterias"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="30">

                </tt-divider-pane>

                <tt-divider-pane ttSize="30">

                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #selectionCriterias>
    <ng-container *ngIf="!!categoryData">
        <!--<tt-select *ngFor="let category of categoryData" *ngIf="category.visible === '1'" [ttLabel]="category.category_name" [(ttModel)]="category.category_keyno" [ttData]="category.items" ttDataId="category_keyno" ttDataName="category_name"></tt-select>-->
    </ng-container>
</ng-template>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-select ng-repeat="category in vm.model.categoryData" ng-if="category.visible === '1'" tt-label="{{category.category_name}}" tt-model="category.category_keyno" tt-change="vm.onCategorySelected(category, $index, $value)" tt-data="category.items" tt-data-id="category_keyno" tt-data-name="category_name"></tt-select>
        <tt-button tt-text="find_categorydataselect" tt-click="vm.loadActivities()" tt-icon="fas fa-sync-alt" tt-spin="vm.model.isLoadingActivities"></tt-button>

        <div ng-if="vm.model.itemsListActivities.length > 0">
            <tt-buttons-radio tt-model="vm.model.categoryDataSelectTabs.active" tt-buttons="vm.model.categoryDataSelectTabs.buttons"></tt-buttons-radio>
            <tt-input-buttons tt-label="search" tt-model="vm.model.filterText" tt-change="vm.model.filterText = $value" tt-buttons="vm.model.filterButtons"></tt-input-buttons>
        </div>
    </tt-card>

    <im-list-directive class="col-xs-12 col-md-4 sp-0" list-items="vm.model.itemsListActivities" badge="" ltype="" design-var="s12t0" filter-val="vm.model.filterText"></im-list-directive>
</tt-page>-->
